import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { IntlProvider } from 'react-intl';
// import './helpers/Firebase';
import AppLocale from './lang';
//import ColorSwitcher from './components/common/ColorSwitcher';
import NotificationContainer from './components/common/react-notifications/NotificationContainer';
import { isMultiColorActive } from './constants/defaultValues';
import main from './views';
import app from './views/app';
import user from './views/user';
import Callback from './views/user/callback';
import error from './views/error';
import AccessDenied from './views/AccessDenied';
import { getDirection } from './helpers/Utils';
import userManager from './helpers/userManage';
import { withRouter } from 'react-router-dom';

const AuthRoute = ({ component: Component, authUser, ...rest }) => {
  if (authUser.user) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }

  // console.log(rest.location.pathname);
  userManager.signinRedirect({
    data: { path: rest.location.pathname },
  });
  return <div />;

  // return (
  //   <Route
  //     {...rest}
  //     render={props =>
  //       authUser.user ? (
  //         <Component {...props} />
  //         // ) : (
  //         //   <Redirect
  //         //     to={{
  //         //       pathname: "/user/login",
  //         //       state: { from: props.location }
  //         //     }}
  //         //   />
  //         // )
  //       ) : <>{setTimeout(() => {
  //         userManager.signinRedirect({
  //           data: { path: rest.location.pathname },
  //         })
  //       }, 0)}
  //           < div />
  //         </>
  //     }
  //   />
  // )
};

class App extends Component {
  componentWillMount() {
    const direction = getDirection();
    if (direction.isRtl) {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
    
  }

  // shouldComponentUpdate(nextProps) {
  // }

  render() {
    let url = this.props.history.location.pathname + this.props.history.location.search;

    if (this.props.history.location.pathname === '/callback') {
      return <Callback {...this.props} />;
    }

    const { locale, loginUser, oidc } = this.props;

    const currentAppLocale = AppLocale[locale];

    if (
      oidc.user === null &&
      !this.props.history.location.pathname.includes('/user/register') &&
      !this.props.history.location.pathname.includes('/user/forgot-password') &&
      !this.props.history.location.pathname.includes('/user/reset-password') &&
      !this.props.history.location.pathname.includes('/user/unsubscribe') &&
      !this.props.history.location.pathname.includes('/user/signup') &&
      !this.props.history.location.pathname.includes('/user/vouchersignup') &&
      !this.props.history.location.pathname.includes('/user/booking') &&
      !this.props.history.location.pathname.includes('/app/pages/stripe') &&
      !this.props.history.location.pathname.includes('/app/pages/salesforce') &&
      !this.props.history.location.pathname.includes('/app/pages/cloudbeds') &&
      !this.props.history.location.pathname.includes('/app/pages/instagram') &&
      !this.props.history.location.pathname.includes('/app/pages/tiktok') &&
      !this.props.history.location.pathname.includes('/app/pages/gmail') &&
      //!this.props.history.location.pathname.includes('/app/pages/propinfo/missing-response') &&
      !this.props.history.location.pathname.includes('/user/invitations')
    ) {
      userManager.signinRedirect({
        data: { path: url },
      });
      return <div />;
    } else if (!oidc.isLoadingUser && oidc.user) {
      return (
        <div className="h-100">
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}
          >
            <React.Fragment>
              <NotificationContainer />
              {/* {isMultiColorActive && <ColorSwitcher />} */}
              <Router>
                <Switch>
                  <Route path="/app" authUser={oidc} component={app} />
                  <Route path="/user" component={user} />
                  <Route path="/error" exact component={error} />
                  <Route path="/access-denied" component={AccessDenied} />
                  <Route path="/" exact component={main} />
                  <Redirect to="/error" />
                </Switch>
              </Router>
            </React.Fragment>
          </IntlProvider>
        </div>
      );
    } else {
      return (
        <div className="h-100">
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}
          >
            <React.Fragment>
              <NotificationContainer />
              {/* {isMultiColorActive && <ColorSwitcher />} */}
              <Router>
                <Switch>
                  <Route path="/user" component={user} />
                </Switch>
              </Router>
            </React.Fragment>
          </IntlProvider>
        </div>
      );
    }
  }
}

const mapStateToProps = ({ authUser, settings, oidc }) => {
  const { user: loginUser } = authUser;
  const { locale } = settings;
  return { loginUser, locale, oidc };
};
const mapActionsToProps = {};

const AppStore = connect(mapStateToProps, mapActionsToProps)(App);

export default withRouter(AppStore);
